import React from 'react';
import { twMerge } from 'tailwind-merge';

interface LabelProps {
  label: string;
  children: React.ReactNode;
  className?: string;
  htmlFor?: string;
}
export default function Labeled({ label, children, className, htmlFor }: LabelProps) {
  return (
    <div className={twMerge('flex w-full flex-col gap-1', className)}>
      <label htmlFor={htmlFor} className="font-medium">
        {label}
      </label>
      {children}
    </div>
  );
}
